const PLUGIN_NAME = 'hal-content';
const COMPONENT_PREFIX = 'hal_';

export { PLUGIN_NAME, COMPONENT_PREFIX };
